import { motion } from "framer-motion";
import { useState } from "react";
import { useLang } from "@/i18n";
import { Landmark, Building2, CreditCard, ShoppingBag, ArrowRight, Download } from "lucide-react";
import { meta } from "@/analytics/metaPixel";
import GuideModal from "./GuideModal";

const DBS = [
  { icon: Building2, k: 1, color: "#003087" },
  { icon: Landmark, k: 2, color: "#0077A3" },
  { icon: CreditCard, k: 3, color: "#00AEEF" },
  { icon: ShoppingBag, k: 4, color: "#128C4B" },
];

export default function Databases({ onCta }) {
  const { t } = useLang();
  const [guideOpen, setGuideOpen] = useState(false);
  return (
    <section id="banche-dati" className="py-20 lg:py-28 bg-white" data-testid="databases-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("dbs.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("dbs.title")}</h2>
          <p className="mt-4 text-base text-[#64748B] leading-relaxed">{t("dbs.sub")}</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {DBS.map(({ icon: Icon, k, color }, i) => (
            <motion.div key={k} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.1 }}
              className="card rounded-3xl p-7 sm:p-8 border-l-4" style={{ borderLeftColor: color }}
              data-testid={`db-card-${k}`}>
              <div className="flex items-center gap-3">
                <span className="w-11 h-11 rounded-xl flex items-center justify-center" style={{ backgroundColor: `${color}14` }}>
                  <Icon size={20} style={{ color }} />
                </span>
                <div>
                  <h3 className="text-lg font-extrabold text-[#003087]">{t(`dbs.${k}t`)}</h3>
                  <p className="text-[11px] font-semibold uppercase tracking-wider" style={{ color }}>{t(`dbs.${k}s`)}</p>
                </div>
              </div>
              <p className="mt-4 text-sm text-[#1A1A1A] leading-relaxed">{t(`dbs.${k}d`)}</p>
              <p className="mt-3 text-xs font-semibold text-[#64748B] leading-relaxed flex gap-2">
                <span className="w-1 h-1 rounded-full bg-[#00AEEF] mt-1.5 shrink-0" />
                {t(`dbs.${k}u`)}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button data-testid="dbs-cta" onClick={() => onCta("visure")}
            className="btn-green inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-bold">
            {t("dbs.cta")} <ArrowRight size={17} />
          </button>
          <button data-testid="dbs-guide-btn" onClick={() => { setGuideOpen(true); meta.trackCustom ? meta.trackCustom("guide_open") : null; }}
            className="btn-outline inline-flex items-center gap-2 rounded-full px-8 py-4 text-base font-bold">
            <Download size={17} /> {t("dbs.guide")}
          </button>
        </div>
      </div>
      <GuideModal open={guideOpen} onClose={() => setGuideOpen(false)} />
    </section>
  );
}
